import React, { useEffect } from "react";

const ChatwootWidget = () => {
  useEffect(() => {
    // Add Chatwoot Settings
    window.chatwootSettings = {
      hideMessageBubble: true,
      position: "right", // This can be left or right
      locale: "en", // Language to be set
      type: "expanded_bubble", // [standard, expanded_bubble]
      // launcherTitle: "Contact Us",
      launcherTitle: "",
    };

    // Load the Chatwoot script
    (function (d, t) {
      const BASE_URL = "https://teamhubpm.9ijakids.com";
      const g = d.createElement(t);
      const s = d.getElementsByTagName(t)[0];
      g.src = BASE_URL + "/packs/js/sdk.js";
      g.defer = true;
      g.async = true;
      s.parentNode.insertBefore(g, s);
      g.onload = function () {
        window.chatwootSDK.run({
          websiteToken: "CMasF6zmJC9oHaNRJFE3mxWT",
          baseUrl: BASE_URL,
        });
      };
    })(document, "script");
    // Cleanup to hide Chatwoot when unmounted
    return () => {
      if (window.$chatwoot) {
        try {
          window.$chatwoot.hide();
        } catch (e) {
          console.error("Scale Chatwoot hide failed", e);
        }
      }
    };
  }, []);

  return null;
};

export default ChatwootWidget;
